import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../../../../services/api';

export function useQuickBooksDepositToAccounts() {
  return useQuery(['quickBooksDepositToAccounts'], async () => {
    const api = getPrivateApi();
    const response = await api.quickbooksGetDepositToAccounts();
    return response.depositToAccounts;
  });
}
